// src/utils/contentfulClient.ts
import { createClient } from "contentful";

const isPreview = process.env.REACT_APP_CONTENTFUL_ENV === "preview";

const client = createClient({
  space: process.env.REACT_APP_CONTENTFUL_SPACE_ID as string,
  accessToken: isPreview
    ? (process.env.REACT_APP_CONTENTFUL_PREVIEW_TOKEN as string)
    : (process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN as string),
  host: isPreview ? process.env.REACT_APP_CONTENTFUL_PREVIEW_HOST : undefined,
});

const extractImageUrl = (asset: unknown): string | null => {
  if (
    typeof asset === "object" &&
    asset !== null &&
    "fields" in asset &&
    typeof (asset as any).fields?.file?.url === "string"
  ) {
    return `https:${(asset as any).fields.file.url}`;
  }

  return null;
};

export const fetchProjects = async () => {
  try {
    const entries = await client.getEntries({
      content_type: "project",
      order: ["-sys.createdAt"],
      include: 2,
    });

    return entries.items.map((item) => {
      const imageField = item.fields.imagePath;

      const images = Array.isArray(imageField)
        ? imageField.map((img) => extractImageUrl(img)).filter(Boolean)
        : extractImageUrl(imageField)
        ? [extractImageUrl(imageField)]
        : [];

      return {
        name: item.fields.title,
        link: item.fields.link,
        description: item.fields.description,
        orientation: item.fields.orientation || "left",
        technologies: item.fields.technologies,
        isCurrent: item.fields.current,
        fromDate: item.fields.fromDate,
        toDate: item.fields.toDate,
        isCompleted: item.fields.isCompleted,
        images,
      };
    });
  } catch (error) {
    console.error("Error fetching projects from Contentful:", error);
    return [];
  }
};
